import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Header from "../layout/header4";
import Footer from "../layout/footer.jsx";
import {
  useServicesContent,
  useHomeSliderContent4,
} from "../element/SliderContent";
import ClientSlider1 from "../element/clientSlider1";
import ServicesSlider3 from "../element/servicesSlider3";
import HomeSlider from "../element/homeslider1";
import DualSlider from "../element/dualSlider";
import ScrollToTop from "../element/scrollToTop";
import "../../css/plugins.css";
import "../../css/style.css";
import "../../css/skin/skin-1.css";
import "../../css/templete.min.css";

const Home = () => {
  const { t } = useTranslation();
  const homeSliderContent4 = useHomeSliderContent4();
  const servicesContext = useServicesContent();

  return (
    <>
      <Helmet>
        <title>{t("home.metaTitle")}</title>
        <meta name="description" content={t("home.metaDescription")} />
      </Helmet>

      <Header />
      <HomeSlider data={homeSliderContent4} contentWrapperCls="sliderStyle4" />

      <div className="page-content bg-white">
        <div className="content-block">
          <div
            className="section-full call-action bg-primary wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.2s"
          ></div>

          <div
            className="section-full content-inner bg-white wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.4s"
          >
            <div className="container">
              <div className="on-show-slider">
                <DualSlider />
              </div>
            </div>
          </div>

          <div
            className="section-full content-inner bg-gray wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.6s"
          >
            <div className="container">
              <div className="section-head text-black text-center">
                <h2 className="title">{t("home.servicesTitle")}</h2>
                <p>{t("home.servicesDescription")}</p>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <ServicesSlider3
                    data={servicesContext}
                    iconWrapperCls="icon-xl m-b20 text-primary radius"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className="section-full content-inner-2 bg-gray wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.6s"
          >
            <div className="container">
              <div className="section-head text-black text-center">
                <h2 className="title text-capitalize">
                  {t("home.partnersTitle")}
                  <br />
                  <span style={{ color: "#6d6e70" }}>
                    {t("home.partnersSubtitle")}
                  </span>
                </h2>
              </div>
              <ClientSlider1 />
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ScrollToTop className="style1 white icon-up" />
    </>
  );
};

export default Home;
